import { Article, PictureAsPdf, Image, GridOn, Slideshow, Description, InsertDriveFile } from '@mui/icons-material';
import { Avatar, Box } from '@mui/material';
import { Colors } from 'src/shared/components/styles/colors';
import { MimeTypeEnum } from 'src/shared/models/enums/mimeType.enum';

type ContentIcon = { types: MimeTypeEnum[]; icon: JSX.Element; color: string };

export const contentIcons: ContentIcon[] = [
  {
    types: [MimeTypeEnum.ImageJpeg, MimeTypeEnum.ImagePng, MimeTypeEnum.ImageGif, MimeTypeEnum.ImageSvg],
    icon: <Image />,
    color: Colors.ColorBox.Blue,
  },
  { types: [MimeTypeEnum.Pdf], icon: <PictureAsPdf />, color: Colors.ColorBox.Blue },
  {
    types: [MimeTypeEnum.ExcelXls, MimeTypeEnum.ExcelXlsx, MimeTypeEnum.Csv],
    icon: <GridOn />,
    color: Colors.ColorBox.Blue,
  },
  { types: [MimeTypeEnum.WordDoc, MimeTypeEnum.WordDocx], icon: <Description />, color: Colors.ColorBox.Blue },
  { types: [MimeTypeEnum.Ppt, MimeTypeEnum.Pptx], icon: <Slideshow />, color: Colors.ColorBox.Blue },
  {
    types: [MimeTypeEnum.PlainText, MimeTypeEnum.Json, MimeTypeEnum.Xml],
    icon: <Article />,
    color: Colors.ColorBox.Blue,
  },
];

const defaultPresentation: ContentIcon = {
  types: [],
  icon: <InsertDriveFile />,
  color: Colors.ColorBox.Blue,
};

export const getIkonForMime = (mime: MimeTypeEnum): ContentIcon => contentIcons.find((c) => c.types.includes(mime)) ?? defaultPresentation;

type DocumentPresentationProps = {
  contentType: MimeTypeEnum;
};

export const DocumentIkonHandler = ({ contentType }: DocumentPresentationProps) => {
  const { icon, color } = getIkonForMime(contentType);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Avatar sx={{ mr: 2, bgcolor: color }}>{icon}</Avatar>
    </Box>
  );
};
